/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Speed_BiologyInputs */

const en_onboarding_speed_biology = /** @type {(inputs: Onboarding_Speed_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const es_onboarding_speed_biology = /** @type {(inputs: Onboarding_Speed_BiologyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biología`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {Onboarding_Speed_BiologyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_speed_biology = /** @type {((inputs?: Onboarding_Speed_BiologyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Speed_BiologyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_speed_biology(inputs)
	return en_onboarding_speed_biology(inputs)
});